import "./OurStory.css";

import StoryHero from "../../components/StoryHero/StoryHero";
import StoryIntro from "../../components/StoryIntro/StoryIntro";
import HeritageSection from "../../components/HeritageSection/HeritageSection";
import FounderSection from "../../components/FounderSection/FounderSection";
import CraftsmanshipSection from "../../components/CraftsmanshipSection/CraftsmanshipSection";
/*import TimelineSection from "../../components/TimelineSection/TimelineSection";
import GallerySection from "../../components/GallerySection/GallerySection";
import Testimonials from "../../components/Testimonials/Testimonials";*/

const OurStory = () => {
  return (
    <>
      <StoryHero />

      <StoryIntro />

      <HeritageSection />

      <CraftsmanshipSection />

    
    </>
  );
};

export default OurStory;